import { render, staticRenderFns } from "./cms-menu-row.vue?vue&type=template&id=6b5c13c0&scoped=true&"
import script from "./cms-menu-row.vue?vue&type=script&lang=js&"
export * from "./cms-menu-row.vue?vue&type=script&lang=js&"
import style0 from "./cms-menu-row.vue?vue&type=style&index=0&id=6b5c13c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5c13c0",
  null
  
)

export default component.exports